import type { MetricRecord } from "@/metrics/runtime"
import { SelectionChip } from "@coval/ui"

import { resolveMetricDisplayName } from "@/utils/formatting/format-metric-display-results"

interface MetricGridProps {
  selectedMetrics: string[]
  metricRecords: Record<string, MetricRecord>
  onRemoveMetric: (metricId: string) => void
  instanceId: string
}

export function MetricGrid({
  selectedMetrics,
  metricRecords,
  onRemoveMetric,
}: MetricGridProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {selectedMetrics.map((metricId) => {
        const displayName = resolveMetricDisplayName(
          metricRecords[metricId]?.metric_display_name,
          metricRecords[metricId]?.metric_name || metricId,
        )

        return (
          <SelectionChip
            key={metricId}
            label={displayName}
            onRemove={() => onRemoveMetric(metricId)}
          />
        )
      })}
    </div>
  )
}
